import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Select,
  Toolbar,
  Typography,
  FormControl,
  InputBase,
  MenuItem,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";

import PickerMonth from "../../partials/pickerMonth";
import { toolbarStyles } from "./style";

// Style
class EnhancedTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      to: moment().format("MM/YYYY"),
      branchCode: "",
      typeEmotion: "",
    };
    this.typeEmotionArr = ["angry", "sad", "normal", "happy", "love"];
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
  }
  convertDate(date) {
    return moment(date).format("MM/YYYY");
  }
  handleChange(event) {
    let _this = this;
    let value = event.target.value;
    this.setState({ [event.target.name]: value }, function () {
      _this.props.changeChart(
        _this.state.branchCode,
        _this.state.typeEmotion,
        _this.state.to
      );
    });
  }
  handleChangeDate(value, name) {
    const _this = this;
    this.setState({ [name]: value }, function () {
      _this.props.changeChart(
        _this.state.branchCode,
        _this.state.typeEmotion,
        _this.state.to
      );
    });
  }
  renderMonth = (props, month, year, selectedDate) => {
    return <td {...props}>{month + 1}</td>;
  };
  render() {
    const { classes, t, listBranch } = this.props;
    const { to } = this.state;
    return (
      <Toolbar className={classes.root}>
        <div className={classes.title}>
          <Typography
            color="inherit"
            variant="h6"
            className={classes.titleText}
          >
            {t("nps_total")} {this.props.total} {t("nps_interact")}
          </Typography>
        </div>
        <div className={classes.actions}>
          <div className={classes.box}>
            <FormControl className={classes.formControl}>
              <Select
                value={this.state.branchCode}
                onChange={this.handleChange}
                input={
                  <InputBase
                    fullWidth
                    style={{ textTransform: "capitalize" }}
                    classes={{
                      root: classNames(
                        classes.inputRootSelected,
                        classes.inputRoot
                      ),
                      input: classNames(
                        classes.inputInputSelected,
                        classes.inputInput
                      ),
                    }}
                  />
                }
                displayEmpty
                classes={{
                  select: classes.selected,
                }}
                name="branchCode"
                className={classes.selectType}
              >
                <MenuItem key={"-1"} value="">
                  {t("select_branch_with_map_all_branch")}
                </MenuItem>
                {listBranch.map((branch, index) => (
                  <MenuItem
                    key={index}
                    value={branch.branchCode}
                    style={{ textTransform: "capitalize" }}
                  >
                    {branch.branchName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={classes.box}>
            <Typography color="inherit" variant="body1">
              {t("nps_emotion")}
            </Typography>
            <FormControl className={classes.formControl}>
              <Select
                value={this.state.typeEmotion}
                onChange={this.handleChange}
                input={
                  <InputBase
                    fullWidth
                    style={{ textTransform: "capitalize" }}
                    classes={{
                      root: classNames(
                        classes.inputRootSelected,
                        classes.inputRoot
                      ),
                      input: classNames(
                        classes.inputInputSelected,
                        classes.inputInput
                      ),
                    }}
                  />
                }
                displayEmpty
                classes={{
                  select: classes.selected,
                }}
                name="typeEmotion"
                className={classes.selectType}
              >
                <MenuItem value="">{t("nps_all")}</MenuItem>
                {this.typeEmotionArr.map((type, index) => (
                  <MenuItem
                    key={index}
                    value={type}
                    style={{ textTransform: "capitalize" }}
                  >
                    {t("nps_" + type)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={classes.box}>
            <Typography color="inherit" variant="body1">
              {t("dashboard_reaction_toolbar_last_3_months_before")}
            </Typography>
            <div className={classes.inputBase}>
              <PickerMonth
                handleChange={this.handleChangeDate}
                nameInput="to"
                time={to}
              />
            </div>
          </div>
        </div>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(toolbarStyles)(EnhancedTableToolbar)));
